import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { TabsType } from 'foundations-library/types'
import { Tabs } from 'foundations-library/components'
import { getValue } from 'firebase-utils'
import { EnrollmentType } from '../interface/EnrollmentType'

const jss = (theme) => {
    const { colors } = theme['foundations-library']
    return {
        root: {
            width: '660px',
            margin: '0 auto',
            '& .tabs': {
                backgroundColor: colors.neutral[50],
                '& .tab': {
                    backgroundColor: 'transparent',
                    color: colors.neutral[700],
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    '&.active--tab': {
                        backgroundColor: `${colors.neutral[900]}!important`,
                        color: '#fff'
                    }
                }
            }
        }
    }
}

const useStyles = makeStyles(jss)

type PropsType = {
    isWizardShown: boolean
    currentTab: unknown
    brands: unknown[]
    campaigns: unknown[]
    campaignsWithNumber: unknown[]
} & TabsType

/**
 *
 */
const ListPageTabsTabs = ({
    isWizardShown,
    currentTab,
    brands,
    campaigns,
    ...props
}: PropsType): JSX.Element => {
    const styles = useStyles()

    const tabs = useMemo(() => {
        const t: Pick<TabsType, 'items'> = []
        if (
            !isWizardShown &&
            brands.length
        ) {
            t.push({
                value: EnrollmentType.Brand,
                text: getValue('sms_enrollment_brand_tab_title')
            })
            t.push({
                value: EnrollmentType.Campaign,
                text: getValue('sms_enrollment_campaign_tab_title')
            })

            if (campaigns.length) {
                t.push({
                    value: EnrollmentType.SmsNumber,
                    text: getValue('transfer_number_number_assignment_title')
                })
            }
        }

        return t
    }, [isWizardShown, brands.length, campaigns.length])
    return <>
        {tabs.length > 0 && <div className={styles.root}>
            <Tabs
                items={tabs}
                color='neutral'
                {...props}
            />
        </div>}
    </>
}

export default ListPageTabsTabs
